/** Return the stable filter/group key for a unified metric alert. */
export function getMetricAlertCategory(alert: Api.Auth.MetricsAlert) {
  return alert.source || 'unknown';
}

/** The API joins multiple kinds with a Chinese semicolon. */
export function getMetricAlertKinds(alert: Api.Auth.MetricsAlert) {
  return alert.type?.split('；').map(value => value.trim()).filter(Boolean) ?? [];
}
